import { firebaseCloudFunctionService } from '@/libs/api';

export const AUTH_ENDPOINTS = {
  LOOKUP_USER_ACCOUNT: '/lookupUserAccount',
  VERIFY_ACCOUNT: '/verifyUserAccount',
} as const;

export const AuthServices = {
  lookupUserAccount: async (email: string) => {
    const response = await firebaseCloudFunctionService.get<auth.LookupUserAccountResponse>(
      AUTH_ENDPOINTS.LOOKUP_USER_ACCOUNT,
      {
        email,
      },
    );
    return response;
  },

  verifyAccount: async () => {
    const response = await firebaseCloudFunctionService.get<auth.VerifyUserAccountResponse>(
      AUTH_ENDPOINTS.VERIFY_ACCOUNT,
    );
    return response;
  },
};
